import React from 'react';
import { Wallet, CircleArrowDown, CircleArrowUp, UsersRound, Gavel, SaudiRiyal } from 'lucide-react';
import '../../../../../styles/components/cash-flow-card.scss';
import { SaudiRiyalLogo } from '../../../../common/icons';
import { NavLink } from 'react-router-dom';
import { fmt } from '../../../../../utils/common';

class CashFlowCards extends React.Component {
  render() {
    const { data, search } = this.props;
    return (
      <div className="dashboard-content">
        {/* LEFT SIDE - CASH FLOW IN */}
        <div className="flow-card-container cash-in-container">
          <div className="flow-card-header">
            <div className="header-left">
              {/* <div className="accent-bar in-bar"></div> */}
              <div className="cf-main-icon green">
                <CircleArrowDown size={20} strokeWidth={1.8} />
              </div>
              <h2 className="flow-title">Cash Flow IN</h2>
            </div>
            <div className="">
              <div className="final-amount">
                <strong>
                  <SaudiRiyalLogo size={10} color={'#1a6b73'} />
                  <span> {fmt(data?.cash_in_total?.amount || 0)}</span>
                </strong>
              </div>
            </div>
          </div>

          {/* Card 1: Auction Enrollment */}
          <div className="flow-item">
            <div className="item-header">
              <div className="item-header-content">
                <div className="icon-wrapper in-icon">
                  <UsersRound size={20} strokeWidth={2} />
                </div>
                <div className="item-title-section">
                  <h3 className="item-title">AUCTION ENROLLMENT</h3>
                  <span className="item-badge in-badge">
                    {data?.enrollment?.sub_total?.count || 0} Enrollments
                  </span>
                </div>
              </div>
              <NavLink
                to={{
                  pathname: '/cash-flow/auction-enrollment',
                  search: new URLSearchParams(
                    Object.fromEntries(
                      Object.entries({
                        startDate: search?.startDate,
                        endDate: search?.endDate,
                        bidder: search?.bidder,
                        client: search?.client,
                        group: search?.group?.length ? search.group.join(',') : null,
                      }).filter(([_, v]) => v !== null && v !== '' && v !== undefined)
                    )
                  ).toString(),
                }}
                className="details-btn-l2"
              >
                View Details
              </NavLink>
            </div>

            <div className="item-content">
              <div className="amount-line">
                <span className="label">Online Enrollment Received</span>
                <span className="value">
                  <SaudiRiyalLogo size={8} />
                  <span className="amount-text">{fmt(data?.enrollment?.online?.amount || 0)}</span>
                </span>
              </div>
              <div className="amount-line">
                <span className="label">Offline Enrollment Received</span>
                <span className="value">
                  <SaudiRiyalLogo size={8} />
                  <span className="amount-text">{fmt(data?.enrollment?.offline?.amount || 0)}</span>
                </span>
              </div>
              <div className="amount-line subtotal">
                <span className="label subtotal-label">SUBTOTAL RECEIVED</span>
                <span className="value subtotal-value">
                  <SaudiRiyalLogo size={8} />
                  <span className="amount-text">
                    {fmt(data?.enrollment?.sub_total?.amount || 0)}
                  </span>
                </span>
              </div>
              <div className="amount-line balance">
                <span className="label">Wallet Enrollment</span>
                <span className="value balance-value">
                  <SaudiRiyalLogo size={8} />
                  <span className="amount-text">{fmt(data?.enrollment?.wallet?.amount || 0)}</span>
                </span>
              </div>
            </div>
          </div>

          {/* Card 2: Auction Payment */}
          <div className="flow-item">
            <div className="item-header">
              <div className="item-header-content">
                <div className="icon-wrapper in-icon">
                  <Gavel size={20} strokeWidth={2} />
                </div>
                <div className="item-title-section">
                  <h3 className="item-title">AUCTION PAYMENT</h3>
                  <span className="item-badge in-badge">
                    {data?.auction_payment_in?.sub_total?.count || 0} Auctions
                  </span>
                </div>
              </div>
              <NavLink
                to={{
                  pathname: '/cash-flow/auction-payment',
                  search: new URLSearchParams(
                    Object.fromEntries(
                      Object.entries({
                        startDate: search?.startDate,
                        endDate: search?.endDate,
                        bidder: search?.bidder,
                        client: search?.client,
                        group: search?.group?.length ? search.group.join(',') : null,
                      }).filter(([_, v]) => v !== null && v !== '' && v !== undefined)
                    )
                  ).toString(),
                }}
                className="details-btn-l2"
              >
                View Details
              </NavLink>
            </div>

            <div className="item-content">
              <div className="amount-line">
                <span className="label">Client Amount Received (Bid Amount + VAT)</span>
                <span className="value">
                  <SaudiRiyalLogo size={8} />
                  <span className="amount-text">
                    {fmt(data?.auction_payment_in?.client_amount?.amount || 0)}
                  </span>
                </span>
              </div>
              <div className="amount-line">
                <span className="label">Mzadcom VAT Received (Service charge VAT)</span>
                <span className="value">
                  <SaudiRiyalLogo size={8} />
                  <span className="amount-text">
                    {fmt(data?.auction_payment_in?.service_charge_vat?.amount || 0)}
                  </span>
                </span>
              </div>
              <div className="amount-line">
                <span className="label">Mzadcom Profit Received (Service charge)</span>
                <span className="value">
                  <SaudiRiyalLogo size={8} />
                  <span className="amount-text">
                    {fmt(data?.auction_payment_in?.service_charge?.amount || 0)}
                  </span>
                </span>
              </div>
              <div className="amount-line subtotal">
                <span className="label subtotal-label">SUBTOTAL RECEIVED</span>
                <span className="value subtotal-value">
                  <SaudiRiyalLogo size={8} />
                  <span className="amount-text">
                    {fmt(data?.auction_payment_in?.sub_total?.amount || 0)}
                  </span>
                </span>
              </div>
            </div>
          </div>

          {/* Card 3: Wallet Recharge */}
          <div className="flow-item">
            <div className="item-header">
              <div className="item-header-content">
                <div className="icon-wrapper in-icon">
                  <Wallet size={20} strokeWidth={2} />
                </div>
                <div className="item-title-section">
                  <h3 className="item-title">WALLET RECHARGE</h3>
                  <span className="item-badge in-badge">
                    {data?.recharge?.sub_total?.count || 0} Transactions
                  </span>
                </div>
              </div>
              <NavLink
                to={{
                  pathname: '/cash-flow/wallet/recharge',
                  search: new URLSearchParams(
                    Object.fromEntries(
                      Object.entries({
                        startDate: search?.startDate,
                        endDate: search?.endDate,
                        bidder: search?.bidder,
                      }).filter(([_, v]) => v !== null && v !== '' && v !== undefined)
                    )
                  ).toString(),
                }}
                className="details-btn-l2"
              >
                View Details
              </NavLink>
            </div>

            <div className="item-content">
              <div className="amount-line">
                <span className="label">Online Transfer Received</span>
                <span className="value">
                  <SaudiRiyalLogo size={8} />
                  <span className="amount-text">{fmt(data?.recharge?.online?.amount || 0)}</span>
                </span>
              </div>
              <div className="amount-line">
                <span className="label">Offline Transfer Received</span>
                <span className="value">
                  <SaudiRiyalLogo size={8} />
                  <span className="amount-text">{fmt(data?.recharge?.offline?.amount || 0)}</span>
                </span>
              </div>
              <div className="amount-line subtotal">
                <span className="label subtotal-label">SUBTOTAL RECEIVED</span>
                <span className="value subtotal-value">
                  <SaudiRiyalLogo size={8} />
                  <span className="amount-text">{fmt(data?.recharge?.sub_total?.amount || 0)}</span>
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE - CASH FLOW OUT */}
        <div className="flow-card-container cash-out-container">
          <div className="flow-card-header">
            <div className="header-left">
              <div className="cf-main-icon red">
                <CircleArrowUp size={20} strokeWidth={1.8} />
              </div>
              <h2 className="flow-title">Cash Flow OUT</h2>
            </div>
            <div className="">
              <div className="final-amount">
                <strong>
                  <SaudiRiyal size={10} color={'#1a6b73'} />
                  <span> {fmt(data?.cash_out_total?.amount || 0)}</span>
                </strong>
              </div>
            </div>
          </div>

          {/* Card 1: Auction Payment Out */}
          <div className="flow-item">
            <div className="item-header">
              <div className="item-header-content">
                <div className="icon-wrapper out-icon">
                  <Gavel size={20} strokeWidth={2} />
                </div>
                <div className="item-title-section">
                  <h3 className="item-title">AUCTION PAYMENT</h3>
                  <span className="item-badge out-badge">
                    {data?.auction_payment_out?.sub_total?.count || 0} Auctions
                  </span>
                </div>
              </div>
              <NavLink
                to={{
                  pathname: '/cash-flow/auction-payment',
                  search: new URLSearchParams(
                    Object.fromEntries(
                      Object.entries({
                        startDate: search?.startDate,
                        endDate: search?.endDate,
                        bidder: search?.bidder,
                        client: search?.client,
                        group: search?.group?.length ? search.group.join(',') : null,
                      }).filter(([_, v]) => v !== null && v !== '' && v !== undefined)
                    )
                  ).toString(),
                }}
                className="details-btn-l2"
              >
                View Details
              </NavLink>
            </div>

            <div className="item-content">
              <div className="amount-line">
                <span className="label">Client Amount (Bid Amount + VAT)</span>
                <span className="value">
                  <SaudiRiyalLogo size={8} />
                  <span className="amount-text">
                    {fmt(data?.auction_payment_out?.client_amount?.amount || 0)}
                  </span>
                </span>
              </div>

              <div className="amount-line">
                <span className="label">Service charge VAT to VAT account</span>
                <span className="value">
                  <SaudiRiyalLogo size={8} />
                  <span className="amount-text">
                    {fmt(data?.auction_payment_out?.service_charge_vat?.amount || 0)}
                  </span>
                </span>
              </div>

              <div className="amount-line">
                <span className="label">Mzadcom Profit (Service charge)</span>
                <span className="value">
                  <SaudiRiyalLogo size={8} />
                  <span className="amount-text">
                    {fmt(data?.auction_payment_out?.service_charge?.amount || 0)}
                  </span>
                </span>
              </div>
              <div className="amount-line subtotal">
                <span className="label subtotal-label">SUBTOTAL SENT</span>
                <span className="value subtotal-value">
                  <SaudiRiyalLogo size={8} />
                  <span className="amount-text">
                    {fmt(data?.auction_payment_out?.sub_total?.amount || 0)}
                  </span>
                </span>
              </div>
              {/* <div className="amount-line balance">
                  <span className="label">Balance to Send</span>
                  <span className="value balance-value">
                    <SaudiRiyalLogo size={8} />
                    {data?.auction_payment_out?.sub_total?.amount || 0}
                  </span>
                </div> */}
            </div>
          </div>

          {/* Card 2: Wallet Withdrawal */}
          <div className="flow-item">
            <div className="item-header">
              <div className="item-header-content">
                <div className="icon-wrapper out-icon">
                  <Wallet size={20} strokeWidth={2} />
                </div>
                <div className="item-title-section">
                  <h3 className="item-title">WALLET WITHDRAWAL</h3>
                  <span className="item-badge out-badge">
                    {data?.withdrawal?.sub_total?.count || 0} Bank Transfers
                  </span>
                </div>
              </div>
              <NavLink
                to={{
                  pathname: '/cash-flow/wallet/withdrawal',
                  search: new URLSearchParams(
                    Object.fromEntries(
                      Object.entries({
                        startDate: search?.startDate,
                        endDate: search?.endDate,
                        bidder: search?.bidder,
                        client: search?.client,
                        group: search?.group?.length ? search.group.join(',') : null,
                      }).filter(([_, v]) => v !== null && v !== '' && v !== undefined)
                    )
                  ).toString(),
                }}
                className="details-btn-l2"
              >
                View Details
              </NavLink>
            </div>

            <div className="item-content">
              <div className="amount-line">
                <span className="label">Withdrawal Completed</span>
                <span className="value">
                  <SaudiRiyalLogo size={8} />
                  <span className="amount-text">
                    {fmt(data?.withdrawal?.wallet_withdrawal?.amount || 0)}
                  </span>
                </span>
              </div>
              <div className="amount-line">
                <span className="label">Auction Payment using wallet</span>
                <span className="value">
                  <SaudiRiyalLogo size={8} />
                  <span className="amount-text">
                    {fmt(data?.withdrawal?.auction_payment?.amount || 0)}
                  </span>
                </span>
              </div>
              <div className="amount-line subtotal">
                <span className="label subtotal-label">SUBTOTAL SENT</span>
                <span className="value subtotal-value">
                  <SaudiRiyal size={8} />
                  <span className="amount-text">
                    {fmt(data?.withdrawal?.sub_total?.amount || 0)}
                  </span>
                </span>
              </div>
              <div className="amount-line balance">
                <span className="label">Withdrawal Pending</span>
                <span className="value balance-value">
                  <SaudiRiyal size={8} />
                  <span className="amount-text">
                    {fmt(data?.withdrawal?.wallet_pending?.amount || 0)}
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CashFlowCards;
